import React from 'react';
import clsx from 'clsx';

export interface ReportLegalDisclaimerProps {
  className?: string;
  /** Nazwa firmowa rzeczoznawcy (np. "Motocontroler"). Wyświetlana po słowie "Rzeczoznawcę". */
  companyName?: string | null;
}

const TEXT_COLOR = '#606C77';

export const ReportLegalDisclaimer: React.FC<ReportLegalDisclaimerProps> = ({ className, companyName }) => (
  <div className={clsx('text-sm my-4', className)} style={{ color: TEXT_COLOR }}>
    <p className="mb-4">Informacje dotyczące charakteru raportu</p>
    <p className="mb-4">
      Raport został opracowany z zachowaniem najwyższej staranności oraz na podstawie szczegółowo
      zebranych informacji. Dane zawarte w raporcie mają jednak charakter informacyjny i poglądowy.
    </p>
    <p className="mb-4">
      Dlaczego raport nie powinien stanowić jedynej podstawy decyzji zakupowej: Raport
      przygotowywany jest przez Rzeczoznawcę{companyName ? ` ${companyName}` : ''}, którego ocena może być
      częściowo subiektywna i nie zawsze musi pokrywać się z oczekiwaniami lub indywidualną opinią klienta.
    </p>
    <p className="mb-4">
      Uwaga dotycząca zakupu zdalnego: Raport ten nie może stanowić jedynej podstawy do podejmowania
      decyzji o zakupie pojazdu bez osobistego kontaktu z samochodem („zakup zdalny"). Przed
      finalizacją transakcji bezwzględnie wymagane są osobiste oględziny pojazdu.
    </p>
    <p className="mb-3">
      Zalecane działania przed zakupem (których Rzeczoznawca nie wykonuje ze względów
      logistycznych):
    </p>
    <div className="mb-3">
      <p className="mb-1">Weryfikacja techniczna:</p>
      <ol className="list-decimal pl-5 text-sm">
        <li>Kontakt z Autoryzowaną Stacją Obsługi w celu:</li>
        <li>Potwierdzenia historii eksploatacji pojazdu,</li>
        <li>Sprawdzenia kompresji w cylindrach,</li>
        <li>Przeprowadzenia analizy składu mieszanki spalinowej.</li>
      </ol>
    </div>
    <div>
      <p className="mb-1">Weryfikacja prawna:</p>
      <ol className="list-decimal pl-5 text-sm">
        <li>
          Sprawdzenie w odpowiedniej jednostce Policji, czy pojazd nie figuruje jako utracony w
          wyniku kradzieży.
        </li>
        <li>
          Weryfikacja w odpowiednich rejestrach, czy samochód nie jest objęty zastawem rejestrowym
          lub innymi obciążeniami prawnymi.
        </li>
      </ol>
    </div>
  </div>
);
